<script setup>

const props = defineProps({
    locale: {
        type: String,
        default: 'fa',
    },
    limit: {
        type: Number,
        default: null
    }
})

const config = useRuntimeConfig()
const { data, error, status, pending } = await useLazyFetch(`/api/companies/${props.locale}` )

const companies = computed(() => {
    return data.value.body
})

// props.limit !== null ? query.limit = props.limit : query.limit = 100;

</script>


<template>
    <!-- Clients -->
    <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        <!-- Title -->
        <div class=" mx-auto text-center mb-6 md:mb-12">
            <h2 class="text-xl font-semibold md:text-2xl md:leading-tight text-gray-800 dark:text-gray-200">{{
                $t('suppliersHint') }}</h2>
        </div>
        <!-- End Title -->

        <!-- Grid -->
        <FetchWrapper :pending :error>
            <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6">
                <CompanyCard v-for="company in companies" :data="company" />
            </div>
        </FetchWrapper>

        <!-- End Grid -->
    </div>
    <!-- End Clients -->
</template>